import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import type { ClientItem } from 'owa-mail-store';
import { action } from 'satcheljs';

export interface InitializeExtendedCardForItemReadingPaneActionMessage {
    itemReadingPaneViewState: ItemReadingPaneViewState;
    loadedItem: ClientItem;
}
const defaultExport: (
    itemReadingPaneViewState: ItemReadingPaneViewState,
    loadedItem: ClientItem
) => InitializeExtendedCardForItemReadingPaneActionMessage = action(
    'initializeExtendedCardForItemReadingPane',
    (
        itemReadingPaneViewState: ItemReadingPaneViewState,
        loadedItem: ClientItem
    ): InitializeExtendedCardForItemReadingPaneActionMessage => ({
        itemReadingPaneViewState,
        loadedItem,
    })
);
export default defaultExport;
